import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./NameAndDescription.module.sass";

// Screens
import CenterInformations from "./CenterInformations";
import AddressInformations from "./AddressInformations";
import DirectorInformations from "./DirectorInformations";
import ContactInformations from "./ContactInformations";

// Services
import { updateCenter } from "../../../services/center.service";
import { showSuccess, showError } from "../../../services/toast.service";

const NameAndDescription = ({ center: initialCenter }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [centerData, setCenterData] = useState({});
  
  // Initialiser les données du centre lorsque les props changent
  useEffect(() => {
    if (initialCenter) {
      console.log("Centre reçu dans NameAndDescription:", initialCenter);
      setCenterData(initialCenter);
    }
  }, [initialCenter]);

  const handleCenterChange = (e) => {
    const { name, value } = e.target;
    setCenterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (name, value) => {
    setCenterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    // Pour les champs numériques, convertir en nombre
    let finalValue = value;
    if ((name === 'type_of_employer' || name === 'specific_employer') && !isNaN(Number(value))) {
      finalValue = Number(value);
    }
    setCenterData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await updateCenter(centerData.id, centerData);
      showSuccess("Centre mis à jour avec succès!");
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour le centre: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <CenterInformations
              center={centerData}
              onCenterChange={handleCenterChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
            />
            <AddressInformations
              center={centerData}
              onCenterChange={handleCenterChange}
            />
            <DirectorInformations
              center={centerData}
              onCenterChange={handleCenterChange}
              onDropdownChange={handleDropdownChange}
            />
            <ContactInformations
              center={centerData}
              onCenterChange={handleCenterChange}
              onDropdownChange={handleDropdownChange}
              loading={loading}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default NameAndDescription;
